/**
 * @generated SignedSource<<3e47d544307d35632dbb813498497949>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TelemetryIntegrationsSyncInput = {
  clientMutationId?: string | null | undefined;
  data?: ReadonlyArray<JSONKeyValueArrayInput | null | undefined> | null | undefined;
  newLeadInfo?: boolean | null | undefined;
  visitorId: string;
};
export type JSONKeyValueArrayInput = {
  key?: string | null | undefined;
  value?: string | null | undefined;
};
export type TelemetrySync_IntegrationsSync_Mutation$variables = {
  input: TelemetryIntegrationsSyncInput;
};
export type TelemetrySync_IntegrationsSync_Mutation$data = {
  readonly telemetryIntegrationsSync: {
    readonly data: ReadonlyArray<{
      readonly key: string | null | undefined;
      readonly value: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type TelemetrySync_IntegrationsSync_Mutation = {
  response: TelemetrySync_IntegrationsSync_Mutation$data;
  variables: TelemetrySync_IntegrationsSync_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TelemetryIntegrationsSyncPayload",
    "kind": "LinkedField",
    "name": "telemetryIntegrationsSync",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "JSONKeyValue",
        "kind": "LinkedField",
        "name": "data",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TelemetrySync_IntegrationsSync_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TelemetrySync_IntegrationsSync_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8e2456f74906ebd3cb29effc3a9d388c",
    "id": null,
    "metadata": {},
    "name": "TelemetrySync_IntegrationsSync_Mutation",
    "operationKind": "mutation",
    "text": "mutation TelemetrySync_IntegrationsSync_Mutation(\n  $input: TelemetryIntegrationsSyncInput!\n) {\n  telemetryIntegrationsSync(input: $input) {\n    data {\n      key\n      value\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "134de5d6f6930842926b9a2d5c068037";

export default node;
